// The deployment this page searches, fixed when the page is built.
//
// None of it comes from the page's URL. A link carrying
// ?coordinator=attacker.example would otherwise send the visitor's searches
// to whoever wrote the link, and ?models= would have the visitor's query read
// by a model of their choosing. Parcel inlines each process.env value below
// at build time (from the environment of `npm start` / `npm run build`, or a
// .env file next to package.json); unset, the default applies.
//
//   WEBSEARCH_COORDINATOR   host:port of the coordinator (localhost:8080)
//   WEBSEARCH_TLS           1 or 0: reach it over https or http (as the page)
//   WEBSEARCH_MODELS        base URL of the model files (the coordinator's
//                           /v1/models/)
//   WEBSEARCH_EMBED,        other model file names: textembed's tiny test
//   WEBSEARCH_CE            models against a synthetic corpus, say (the
//                           client's defaults)

const env = {
  coordinator: process.env.WEBSEARCH_COORDINATOR,
  tls: process.env.WEBSEARCH_TLS,
  models: process.env.WEBSEARCH_MODELS,
  embed: process.env.WEBSEARCH_EMBED,
  ce: process.env.WEBSEARCH_CE,
};

export const config = {
  coordinator: env.coordinator || "localhost:8080",
  tls: env.tls ? env.tls === "1" : window.location.protocol === "https:",
  modelsBase: env.models || "", // "" = the coordinator's /v1/models/
  embedModel: env.embed || "", // "" = the client's default file name
  ceModel: env.ce || "",
};
